export default "__VITE_ASSET__B3Wqkra0__"